import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Form } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  setChangedFormItems,
  commitChanges,
} from "../organization/organizationSlice";
import { getChangedItems } from "../../components/util/helpers";
import { useIntl } from "react-intl";
import FloatingFormActions from "../../components/forms/FloatingFormActions";
import Spacer from "../../components/layouts/Spacer";
import RestrictedContext from "../../components/util/RestrictedContext";
import { usePermission } from "../../hooks/accessControl";
import { useParams } from "react-router-dom";
import EmployeesSync from "./forms/EmployeesSync";
import PatientsExport from "./forms/PatientsExport";
import AccountingExport from "./forms/AccountingExport";
import SalaryExport from "./forms/SalaryExport";
import RevahaSync from "./forms/RevahaSync";
import ProsectusExport from "./forms/ProsectusExport";
var flatten = require("flat");

const Interfaces = (props) => {
  const { mode } = props;
  const { branchId } = useParams();
  const [form] = Form.useForm();
  const details = useSelector((state) => state.organization.settings);
  const changedItems = useSelector(
    (state) => state.organization.changedItems.changed
  );

  const changedValues = useSelector(
    (state) => state.organization.changedItems.values
  );
  const activeOrganization = useSelector((state) => state.organization.details);

  const saveLoading = useSelector(
    (state) => state.pendingActions["organization/update"]
  );
  const intl = useIntl();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setChangedFormItems({ changed: [], values: [] }));
  }, [dispatch]);

  useEffect(() => {
    form.setFieldsValue(
      flatten(details, {
        safe: true,
      })
    );
  }, [details, form]);

  const onValuesChange = (changedValues, allValues) => {
    const arr = getChangedItems(
      changedValues,
      allValues,
      changedItems,
      details
    );
    dispatch(setChangedFormItems({ changed: arr, values: allValues }));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //pop error notification
  };

  const onDecline = () => {};

  const hasPermission = usePermission(
    branchId,
    "organization.settings",
    "editor"
  );
  return (
    <RestrictedContext.Provider value={{ hasWritePermission: hasPermission }}>
      <Form
        layout="vertical"
        onFinish={() => dispatch(commitChanges())}
        onFinishFailed={onFinishFailed}
        scrollToFirstError
        onValuesChange={onValuesChange}
        form={form}
      >
        <ProsectusExport
          changedItems={changedItems}
          changedValues={changedValues}
          activeOrganization={activeOrganization}
        />
        <AccountingExport
          changedItems={changedItems}
          changedValues={changedValues}
          activeOrganization={activeOrganization}
        />
        <SalaryExport
          changedItems={changedItems}
          changedValues={changedValues}
          activeOrganization={activeOrganization}
        />
        <EmployeesSync
          changedItems={changedItems}
          changedValues={changedValues}
          activeOrganization={activeOrganization}
        />
        <PatientsExport
          changedItems={changedItems}
          changedValues={changedValues}
          activeOrganization={activeOrganization}
        />
        <RevahaSync
          changedItems={changedItems}
          changedValues={changedValues}
          activeOrganization={activeOrganization}
        />

        <Spacer vertical={true} extra={true} />
        <FloatingFormActions
          resource={"employees"}
          action={"editor"}
          onCancel={onDecline}
          mode={mode}
          formName={details.first_name}
          onDecline={onDecline}
          hideDelete={true}
          hideDecline={true}
          saveLoading={saveLoading}
          saveText={intl.formatMessage({
            id: "app.actions.saveChanges",
          })}
          show={changedItems.length > 0}
        />
      </Form>
    </RestrictedContext.Provider>
  );
};

Interfaces.propTypes = {
  mode: PropTypes.string,
  onSubmit: PropTypes.func,
  onFinishFailed: PropTypes.func,
  onDecline: PropTypes.func,
  addImage: PropTypes.func,
  saveLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};
export default Interfaces;
